import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {ApiService} from '../api/ApiService';
import {toastStore} from '../components/AppToast';
import {useHistory} from 'react-router-dom';
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader';
import { useLogPageVisit } from '../utils/logPageVisit';

const Orientation: React.FC = () => {
    useLogPageVisit('LP Re-test', 'User viewed the Re-test page');
    const history = useHistory();
    const {onSheet, onIonScroll} = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);
    const [governmentId, setGovernmentId] = useState("")
    const [showLoading, setShowLoading] = useState(false)

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    const requalifyDriver = () => {
        ApiService.updateOrientation("orientation", {
            ssn: governmentId.replace(/-/g, ""),
            passed: 0,
            disqualified: 0,
            completed: 0,
        }).then(() => {
            toastStore.getState().setSuccessToast('Your request was submitted');
            history.push('/orientationroadtests');
        }).catch(() => {
            toastStore.getState().setToast('Your request could not be submitted. Please check your connection and try again.');
        }).finally(() => {
            setShowLoading(false);
        });
    }

    const handleId = (id: string) => {
        let val = id
        val = val.replace(/\D/g, '');
        val = val.replace(/^(\d{3})/, '$1-');
        val = val.replace(/-(\d{2})/, '-$1-');
        val = val.replace(/(\d)-(\d{4}).*/, '$1-$2');
        return val
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    return (
        <IonPage>
            <LoadDetailHeader title="Retest Driver" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero advance-hero">
                  <div className="advance-hero__eyebrow">Orientation</div>
                  <div className="advance-hero__title home-display">Retest Driver</div>
                  <div className="advance-hero__meta">Re-qualify a driver for an orientation road test</div>
                </div>

                <div className="home-sheet advance-sheet">
                  <div className="home-card training-info-card">
                    <div className="training-info-card__label">Re-qualify Driver</div>
                    <p className="training-info-card__body">
                      Enter the driver's Social Security Number to reset their orientation road test
                      status. The driver will become available for evaluation again.
                    </p>
                  </div>

                  <label className="profile-field">
                    <span className="profile-field__label">SSN</span>
                    <input
                      id="orientation"
                      className="profile-field__input"
                      placeholder="000-00-0000"
                      value={handleId(governmentId)}
                      onChange={e => setGovernmentId(e.target.value!)}
                    />
                  </label>

                  <button
                    type="button"
                    className="profile-submit"
                    disabled={showLoading}
                    onClick={() => {
                        if (showLoading) return;
                        setShowLoading(true);
                        requalifyDriver()
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </IonContent>

            <IonModal isOpen={showLoading} onDidDismiss={() => setShowLoading(false)}>
              <div className="design-a">
                <div className="roadtest-confirm-modal">
                  <div className="roadtest-confirm-modal__title">Submitting</div>
                  <p className="roadtest-confirm-modal__body">
                    Please wait... Your request is being submitted.
                  </p>
                </div>
              </div>
            </IonModal>
        </IonPage>
    );
};

export default Orientation;
